const PROVISIONING_STATUSES = new Set([
  "provision_requested",
  "creating",
  "awaiting_phone_home",
  "awaiting_slack_bridge",
  "deleting",
  "waking",
]);

export function isWorkspaceProvisioning(status: string | null | undefined): boolean {
  return status != null && PROVISIONING_STATUSES.has(status);
}

/** Prefer terminal DB-backed status over stale action/poll hints. */
export function resolveLiveWorkspaceStatus(
  serverStatus: string | null | undefined,
  pollHint: string | null | undefined,
): string | null {
  if (serverStatus && !isWorkspaceProvisioning(serverStatus)) {
    return serverStatus;
  }
  return pollHint ?? serverStatus ?? null;
}
